import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TimeService } from '@rd/core/services/time/time.service';
import {
  LoyaltyProgram,
  LoyaltyProgramCapability,
  LoyaltyProgramCategory,
} from '@rd/types';
@Injectable({
  providedIn: 'root',
})
export class LoyaltyProgramHelper {
  constructor(
    private timeService: TimeService,
    public translateService: TranslateService,
  ) {}

  categoryTranslationKey(category: LoyaltyProgramCategory | 'all'): string {
    if (category === 'all') {
      return 'app.all';
    } else {
      return `transfer.programs.categories.${category}`;
    }
  }

  // TODO: Change when the logic for having special offers exists on the back-end
  hasSpecialOffer(loyaltyProgram: LoyaltyProgram | undefined): boolean {
    return false;
    // return !!(loyaltyProgram && loyaltyProgram.id);
  }

  isFullyLoaded(loyaltyProgram: LoyaltyProgram | undefined): boolean {
    return !!(loyaltyProgram && loyaltyProgram.id);
  }

  checkoutUrl(loyaltyProgram: LoyaltyProgram): string {
    return `/transfer/checkout/${loyaltyProgram.id}`;
  }

  transferTime(processingDelay: number): string {
    return this.timeService.timeFromNow(processingDelay);
  }

  getCashBackCapability(
    loyaltyProgram: LoyaltyProgram,
  ): LoyaltyProgramCapability {
    const { category, cashBackToAccountCapability, cashBackToCardCapability } =
      loyaltyProgram;
    return category === LoyaltyProgramCategory.CashbackToCard
      ? cashBackToCardCapability
      : cashBackToAccountCapability;
  }

  targetMinimumTransferPoints(loyaltyProgram: LoyaltyProgram): number {
    return loyaltyProgram.transferRate
      ? loyaltyProgram.transferRate.minimumTransfer *
          loyaltyProgram.transferRate.exchangeRate
      : 0;
  }

  getRedeemDurationText(processingDelay: number): string {
    const redeemDuration = this.transferTime(processingDelay);

    return redeemDuration ===
      this.translateService.instant(
        'transfer.checkout.estimated_transfer_time_instant',
      )
      ? this.translateService.instant(
          'transfer_v2.review.membership_details_instantly',
        )
      : this.translateService.instant(
          'transfer_v2.review.membership_details_in_days',
          { deliveryDays: redeemDuration },
        );
  }
}
